import ViewportRoot from "./sframe/ViewportRoot";
import ApiProxy from "./ApiProxy";

enum StyleModes {
  mobie = 0,
  pc = 1,
  default = 1
}

export enum Direction {
  TopLeft = 7,
  Top = 8,
  TopRight = 9,
  Left = 4,
  Center = 5,
  Right = 6,
  BottomLeft = 1,
  Bottom = 2,
  BottomRight = 3
}

// const _localSetting =
// {
//   testEnv: "local",
//   useApiSchemaData: true,
//   logSendingData: true,
//   apiPath: "./static/api-data/",
//   apiExt: ".json",
//   recaptchaSiteKey: "6LfaorUUAAAAADNj-eAjCnvQlLgUAwVJFBzXrtSx",
//   googleMapKey: "AIzaSyA_JlayIm2lETF6jUm9rw88vcbKZrFCV-A",
// };

const _testSetting =
{
  testEnv: "hikaru-test",
  useApiSchemaData: true,
  logSendingData: true,
  apiPath: "./static/api-data/",
  apiExt: ".json"
};

export default class GS {
  static setting = {
    testEnv: "",
    useApiSchemaData: false,
    logSendingData: false,
    apiPath: "/api/frontend/",
    apiExt: "",
    recaptchaSiteKey: "6Ld7kOMlAAAAAN5gMiHv9gpeEVFt4E9qhI-qbx0H",
    googleMapKey: "AIzaSyAlClcKiKN7vOX7og3Bc6avp3j_R6KNl2E"
  };

  static MOBILE_WIDTH = 640;
  static SCROLL_WIDTH = 1280;
  static MAX_WIDTH = 1440;

  static reviewMaxRating: number = 5;

  static search = {
    keywordMaxLength: 20,
    pageSize: 10,
    getQueryUrl: (queryString: string) => {
      return ApiProxy.getCommonPageData().search_page_path + "?" + queryString
    }
  }

  static ezpointRatio = {
    pointToCash: .1,
    priceToPoint: .02
  };

  static ezpointToCash(value: number) {
    return Math.floor(GS.ezpointRatio.pointToCash * value);
  }

  static priceToEzpoint(value: number) {
    const calculatedValue = GS.ezpointRatio.priceToPoint * value;
    const roundedValue = Math.round(calculatedValue * 10) / 10;
    if (roundedValue < 0) return 0
    return roundedValue;
  }

  static sportsVoucherToEzpoint(value: number, voucherToPoint: number) {
    const calculatedValue = voucherToPoint * value;
    const roundedValue = Math.round(calculatedValue * 10) / 10;
    if (roundedValue < 0) return 0
    return roundedValue;
  }

  static SPORTS_VOUCHER_BONUS_RATE: number = 0;

  static getSportsVoucherBonus(amount: number) {
    return Math.ceil(amount * this.SPORTS_VOUCHER_BONUS_RATE);
  }

  static DATE_FORMAT: string = "YYYY-MM-DD";
  static DEFAULT_COUNTRY: string = "tw";
  static navHeight = {
    0: 60,
    1: 70
  };

  static init() {
    let host = ["local.savorks.com", "www.hikaru.com.tw", "hikaru.com.tw", "127.0.0.1"];
    if (host.includes(window.location.host))
      $.extend(this.setting, _testSetting);
    ApiProxy.setLogSendingData(this.setting.logSendingData);
  }

  static getNavHeight() {
    let i: StyleModes = ViewportRoot.index,
      v = this.navHeight[i];
    return v === undefined ? this.navHeight[StyleModes.default] : v;
  }
}